import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — an L-shaped sectional sofa spanning 2x2 tiles: a ~1.9 m run
// along X (back on -Z) joined to a ~1.6 m run along Z (back on -X), in the
// same styling family as sofa-two-seat. True metric size, base on y = 0.
const FABRIC = "#8a9aa8";
const FABRIC_DARK = "#758898";
const WALNUT = "#7a5a3a";

export const sofaCorner = defineModel({
  id: "sofa-corner",
  batchId: "modern",
  name: "Sofa (corner)",
  tags: ["modern", "interior", "furniture", "seating", "living-room"],
  summary: "An L-shaped contemporary sectional sofa.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // base frames — the two joined runs
      { geometry: new THREE.BoxGeometry(1.9, 0.28, 0.85), color: FABRIC, position: [0, 0.24, -0.575] },
      { geometry: new THREE.BoxGeometry(0.85, 0.28, 1.6), color: FABRIC, position: [-0.525, 0.24, -0.15] },
      // backrests
      { geometry: new THREE.BoxGeometry(1.9, 0.5, 0.2), color: FABRIC, position: [0, 0.6, -0.9] },
      { geometry: new THREE.BoxGeometry(0.2, 0.5, 1.6), color: FABRIC, position: [-0.85, 0.6, -0.15] },
      // armrests at each free end
      { geometry: new THREE.BoxGeometry(0.18, 0.32, 0.85), color: FABRIC, position: [0.86, 0.54, -0.575] },
      { geometry: new THREE.BoxGeometry(0.85, 0.32, 0.18), color: FABRIC, position: [-0.525, 0.54, 0.56] },
      // seat cushions — corner square, two on the X run, one on the Z run
      { geometry: new THREE.BoxGeometry(0.62, 0.14, 0.62), color: FABRIC_DARK, position: [-0.53, 0.45, -0.52] },
      { geometry: new THREE.BoxGeometry(0.48, 0.14, 0.62), color: FABRIC_DARK, position: [0.03, 0.45, -0.52] },
      { geometry: new THREE.BoxGeometry(0.48, 0.14, 0.62), color: FABRIC_DARK, position: [0.53, 0.45, -0.52] },
      { geometry: new THREE.BoxGeometry(0.62, 0.14, 0.62), color: FABRIC_DARK, position: [-0.5, 0.45, 0.13] },
      // back cushions, tilted against the backrests
      { geometry: new THREE.BoxGeometry(0.62, 0.4, 0.12), color: FABRIC_DARK, position: [-0.53, 0.62, -0.78], rotation: [-0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.48, 0.4, 0.12), color: FABRIC_DARK, position: [0.03, 0.62, -0.78], rotation: [-0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.48, 0.4, 0.12), color: FABRIC_DARK, position: [0.53, 0.62, -0.78], rotation: [-0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.4, 0.62), color: FABRIC_DARK, position: [-0.73, 0.62, 0.13], rotation: [0, 0, 0.12] },
      // wooden feet
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [0.88, 0.05, -0.2] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [0.88, 0.05, -0.93] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [-0.88, 0.05, -0.93] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [-0.88, 0.05, 0.58] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [-0.17, 0.05, 0.58] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [-0.17, 0.05, -0.2] },
    ];
  },
  animations: [],
});
